
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 200 200","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M86.508 86.257c0 10.848 5.503 22.55 17.613 22.55 8.98 0 18.062-7.01 18.062-22.709 0-13.763-7.139-23.002-17.763-23.002-8.658 0-17.911 6.08-17.911 23.162h-.001zM108.686 43C130.4 43 145 60.198 145 85.796c0 25.197-15.381 42.79-37.368 42.79-10.484 0-17.198-4.491-20.71-7.74.026.77.043 1.633.043 2.554v34.168H64.47V66.53c0-1.324-.423-1.742-1.734-1.742H55V44.852h18.875c8.69 0 10.914 4.422 11.338 7.831C88.741 48.73 96.053 43 108.686 43z"}})]),_c('use',{attrs:{"fill":"#FFF","xlink:href":"#a","fill-rule":"evenodd"}})])
          )
        }
      }
    